import React, { memo, useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { Animated, DeviceEventEmitter, Dimensions, Pressable, StyleSheet, Text, View } from 'react-native';
import { getCleanUrl, isWeb } from '../../utils/Helper';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { ImageComp } from '../../components/Image/Image';
import HomePage from './HomePage';
import { setCurrentHomePageWidgetList } from '../../Redux/Reducers/deviceConfigReducer';
import { useNavigation } from '@react-navigation/native';
import HotelListWidget from '../selectLocation/hotelListWidget';
import { chatKeys, doorKey, locationSelectorWidget, myStayTab, notificationKey } from '../../config/Constant';
import { useCssStyle } from '../../customHook/getCssStyle';
import { handleOpenChat } from '../chat/initializeChat';
import CustomPressable from '../../components/customPressable/customPressable';
import { setShowLoginModal, setShowOfflineMessage } from '../../Redux/Reducers/appConfigReducer';
import { DOOR_KEY_FLOW, NOTIFICATION } from '../../navigation/StackNavigator/routes';
import triggerHapticFeedback from '../../js/vibration';

import TabBar from './TabBar';
import FloatingWidget from '../../components/widgetTypes/floatingWidget';
import Notification from '../notification/notification';
import BookmarkPopup from '../../components/bookmarkPopup';

// Bottom Tab Navigator
const Tab = createBottomTabNavigator();

const MainLayout = () => {


  const navigation = useNavigation();
  const dispatch = useDispatch();
  const getStyles = useCssStyle();

  // Combine selectors to reduce re-renders
  const {
    isOnline,
    isLoggedIn,
    redirectToTabId,
    isBookingFound,
    chatInterface,
    webAppWidgetsInfo,
    currentLayout,
    showBookmarkPopup
  } = useSelector(state => ({
    isOnline: state.appConfigSlice.isOnline,
    isLoggedIn: state.appConfigSlice.isLoggedIn,
    redirectToTabId: state.appConfigSlice.redirectToTabId,
    isBookingFound: state.checkInSlice.bookingStatus.isBookingFound,
    chatInterface: state.appPreservedConfigSlice.chatInterface,
    webAppWidgetsInfo: state.deviceConfigSlice.webAppWidgetsInfo,
    currentLayout: state.deviceConfigSlice.currentLayout,
    showBookmarkPopup: state.appConfigSlice.showBookmarkPopup
  }), shallowEqual);

  const tabDetails = currentLayout?.tabDetails || [];
  const widgetList = currentLayout?.scrollableWidgets || [];

  const [initialTab, setInitialTab] = useState({});




  const handleFooterNavClick = (tab, bottomTabNavigation) => {
    
    triggerHapticFeedback('effectTick');

    if (chatKeys.includes(tab.uniqueKey)) {

      if(!isOnline) {
          dispatch(setShowOfflineMessage(true));
          return;
      }

      dispatch(handleOpenChat());
      return;
    }

    if (doorKey.includes(tab.uniqueKey)) {

      if(!isOnline) {
        dispatch(setShowOfflineMessage(true));
        return;
      }

      navigation.navigate(DOOR_KEY_FLOW)
      return;
    }

    const currentRoute = bottomTabNavigation.getState().routes[bottomTabNavigation.getState().index];

    if (currentRoute.name === tab.uniqueKey) {
      // Tab is already focused, trigger scrollToTop
      DeviceEventEmitter.emit('scrollToTop', tab);
    } else {
      // Tab is not focused, navigate to it
      bottomTabNavigation.navigate(tab.uniqueKey);
    }
  };

  const getDefaultFooter = () => {
    let defaultTab = tabDetails[0];

    if (tabDetails?.length > 0) {
    if (redirectToTabId) {
      // Find the tab with the uniqueKey that matches initialTabId
      const requiredTabItem = tabDetails.find(tabItem =>
        redirectToTabId.includes(tabItem.uniqueKey.replace(/ /g, '').toLowerCase())
      );
      if (requiredTabItem) {
        defaultTab = requiredTabItem;
      }
    } else if (isLoggedIn || isBookingFound) {
      // Find the "my stay" tab
      const myStayTabItem = tabDetails.find(tabItem =>
        myStayTab.includes(tabItem.uniqueKey.replace(/ /g, '').toLowerCase())
      );

      if (myStayTabItem) {
        defaultTab = myStayTabItem;
      }
    }

    console.log(defaultTab);
    setInitialTab(defaultTab);
    }
  };

  useEffect(() => {    
    // select required footer tab
    if(tabDetails?.length){
      getDefaultFooter();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabDetails]);


  const GetTabComp = (tabData) => {
    const matchedWidgetList = widgetList.find((item) => item.uniqueKey == tabData.uniqueKey);

    if (locationSelectorWidget.some(el => el === tabData.uniqueKey)) {
      return <HotelListWidget tabDetails={tabData} />;
    }

    if(notificationKey.some(el => el === tabData.uniqueKey)){
      return <Notification hideBackButton={true} tabDetails={tabData} />;
    }

    return <HomePage widgetList={matchedWidgetList?.widgets} tabDetails={tabData} />;
  }

  return (
    <>
    {currentLayout?.floatingWidgets?.length > 0 && <FloatingWidget listItemData={currentLayout.floatingWidgets} />}
    {Object.keys(initialTab)?.length > 0 && (
      <Tab.Navigator
        backBehavior="none"
        key={initialTab.uniqueKey}
        initialRouteName={initialTab.uniqueKey}
        tabBar={(props) => <TabBar {...props} handleFooterNavClick={handleFooterNavClick} />}
        screenOptions={{
          headerShown: false,
          freezeOnBlur: true,
          detachInactiveScreens: false,
        }}
      >
        {tabDetails.map((tab, index) => {

          if (chatKeys.includes(tab.uniqueKey) && !chatInterface.chatInitialized) {
            return null;
          }
          return (
            <Tab.Screen
              key={tab.uniqueKey}
              name={tab.uniqueKey}
              children={() => GetTabComp(tab)}
            />
          );
        })}
      </Tab.Navigator>
    )}
    {showBookmarkPopup && <BookmarkPopup />}
    </>
  );
};


export default memo(MainLayout);
